/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Create_Set_LabelInputs */



/**
* | output |
* | --- |
* | "Create new tag set" |
*
* @param {Tags_Manager_Create_Set_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_create_set_label = /** @type {((inputs?: Tags_Manager_Create_Set_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Create_Set_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Creer un nouvel ensemble de tags")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neues Tag-Set erstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea un nuovo set di tag")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создать новый набор тегов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear nuevo conjunto de etiquetas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建新的标签集")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいタグセットを作成する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया टैग सेट बनाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criar novo conjunto de etiquetas")
	return /** @type {LocalizedString} */ ("Create new tag set")
});